import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconTrendingUpComponent } from "./med-icon-trending-up.component";

@NgModule({
  declarations: [
    MedIconTrendingUpComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconTrendingUpComponent,
  ],
})
export class MedIconTrendingUpModule { }
